<template>
    <div>

        <p class="mb-3">
            Raises <strong>one invoice per checked job</strong> and emails it to the customer
            straight away. Jobs waiting on a purchase order are left for the PO Manager.
        </p>

        <div class="btn-group">
            <button
                type="button"
                class="btn btn-sm btn-primary"
                :disabled="working"
                @click="confirmThenGenerate()"
            >
                <span v-if="working">
                    <i class="fa fa-spinner fa-spin me-1"></i> Generating&hellip;
                </span>
                <span v-else>
                    Generate Invoices
                </span>
            </button>
        </div>

    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';

export default {

    data () {
        return {
            working: false,
        }
    },

    methods: {

        /**
         * Read straight from the checkboxes at submit time, matching
         * BulkUpdate.vue. The table redraws on every page and sort, so holding
         * our own copy of the selection would go stale.
         */
        checkedJobIds() {
            const ids = [];

            window.jQuery('.bulk-update-checkbox:checked').each(function (_, el) {
                ids.push(JSON.parse(el.value).id);
            });

            return ids;
        },

        confirmThenGenerate() {
            const ids = this.checkedJobIds();

            if (ids.length === 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'No jobs checked',
                    text: 'Tick the jobs you want to invoice first.',
                });

                return;
            }

            const jobWord = ids.length === 1 ? 'job' : 'jobs';

            // "up to", because whether a job is still waiting on a purchase
            // order is only known server side. Overstating would be worse the
            // other way round, but this should not promise invoices that the
            // PO interlock is going to skip.
            const body = ids.length === 1
                ? 'This raises <strong>one invoice</strong> for the checked job and '
                    + '<strong>emails it to the customer immediately</strong>.'
                    + '<br><br>If the job is still waiting on a purchase order it will be skipped.'
                : `This raises <strong>up to ${ids.length} invoices</strong>, one per job, and `
                    + '<strong>emails each one to the customer immediately</strong>.'
                    + '<br><br>Any job still waiting on a purchase order will be skipped.';

            Swal.fire({
                icon: 'warning',
                title: `Invoice ${ids.length} ${jobWord}?`,
                html: `${body}<br><br>This cannot be undone.`,
                showCancelButton: true,
                confirmButtonText: `Yes, invoice ${ids.length} ${jobWord}`,
                confirmButtonColor: '#dc3545',
                cancelButtonText: 'Cancel',
                width: '600px',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.generate(ids);
                }
            });
        },

        generate(ids) {
            this.working = true;

            const data = new FormData();
            data.append('ids', ids.join(','));

            axios.post(route('api.movements.jobs.bulk.generate-invoices'), data)
                .then((response) => {
                    this.reportOutcome(response.data);
                })
                .catch((error) => {
                    this.working = false;
                    this.reportError(error);
                });
        },

        /**
         * A partial result is the normal case, not an error: skipped jobs each
         * carry a reason the operator needs to read, so those are shown in a
         * modal rather than a toast that disappears.
         */
        reportOutcome(result) {
            const generated = result.generated ?? 0;
            const skipped = result.skipped ?? 0;
            const failed = result.failed ?? 0;
            const messages = result.messages ?? [];

            const summary = `<p class="mb-2"><strong>${generated}</strong> invoiced`
                + `, <strong>${skipped}</strong> skipped`
                + `, <strong>${failed}</strong> failed.</p>`;

            if (messages.length === 0) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: `${generated} invoiced`,
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                }).then(() => window.location.reload());

                return;
            }

            const detail = messages.map((message) => `<li>${message}</li>`).join('');

            Swal.fire({
                icon: generated > 0 ? 'warning' : 'error',
                title: 'Invoices generated',
                html: `${summary}<ul class="text-start small mb-0">${detail}</ul>`,
                width: '700px',
                confirmButtonText: 'Close',
            }).then(() => window.location.reload());
        },

        reportError(error) {
            if (!error.response) {
                return;
            }

            let allErrors = '';

            if (error.response?.data?.errors) {
                Object.entries(error.response.data.errors).forEach(([, messages]) => {
                    messages.forEach((message) => {
                        allErrors += '<p class="mb-0">' + message + '</p>';
                    });
                });
            } else if (error.response?.data?.message) {
                allErrors = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Could not generate invoices',
                html: allErrors,
                width: '600px',
                confirmButtonText: 'Dismiss',
                confirmButtonColor: '#dc3545',
            });
        },

    }
}
</script>
